(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ajwa-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after')) customElements.define('before-after', class extends HTMLElement { connectedCallback(){this.querySelector('input')?.addEventListener('input',e=>this.style.setProperty('--ba-position',`${e.target.value}%`));} });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ajwa-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ajwa-editorial-hero')) {
    customElements.define(
      'ajwa-editorial-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('[data-slide]')];
          this.dots = [...this.querySelectorAll('[data-dot]')];
          this.thumbs = [...this.querySelectorAll('[data-thumb]')];
          this.contentPanels = [...this.querySelectorAll('[data-content]')];
          this.currentIndex = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
          this.abortController = new AbortController();
          this.signal = this.abortController.signal;

          this._initParallax();

          if (this.slides.length < 2) return;

          this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.currentIndex - 1, true), { signal: this.signal });
          this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.currentIndex + 1, true), { signal: this.signal });

          this.dots.forEach((dot) => {
            dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true), { signal: this.signal });
          });

          this.thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => this.show(Number(thumb.dataset.thumb), true), { signal: this.signal });
          });

          this.addEventListener('mouseenter', () => this.stop(), { signal: this.signal });
          this.addEventListener('mouseleave', () => this.start(), { signal: this.signal });
          this.addEventListener('focusin', () => this.stop(), { signal: this.signal });
          this.addEventListener('focusout', () => this.start(), { signal: this.signal });

          this._initSwipe();
          document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()), { signal: this.signal });
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              if (!this.contains(event.target)) return;
              const selected = this.slides.findIndex((s) => s.dataset.blockId === event.detail.blockId);
              if (selected >= 0) this.show(selected, true);
            },
            { signal: this.signal }
          );

          window.setTimeout(() => this.start(), 9000);
        }

        disconnectedCallback() {
          this.stop();
          this.abortController?.abort();
        }

        show(index, restartTimer = false) {
          const next = (index + this.slides.length) % this.slides.length;

          this.slides.forEach((s, i) => {
            s.classList.toggle('is-active', i === next);
            s.setAttribute('aria-hidden', String(i !== next));
          });
          this.dots.forEach((d, i) => {
            d.classList.toggle('is-active', i === next);
            d.setAttribute('aria-current', String(i === next));
          });
          this.thumbs.forEach((t, i) => {
            t.classList.toggle('is-active', i === next);
            t.setAttribute('aria-current', String(i === next));
          });
          this.contentPanels.forEach((p, i) => p.classList.toggle('is-active', i === next));
          this.currentIndex = next;

          if (restartTimer) { this.stop(); this.start(); }
        }

        start() {
          if (this.dataset.autoplay !== 'true' || this.timer || document.hidden) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const interval = Math.max(3000, Number(this.dataset.interval) || 5000);
          this.timer = window.setInterval(() => this.show(this.currentIndex + 1), interval);
        }

        stop() {
          window.clearInterval(this.timer);
          this.timer = null;
        }

        _initSwipe() {
          let startX = 0;
          let startY = 0;
          let dragging = false;

          this.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            dragging = true;
          }, { passive: true, signal: this.signal });

          this.addEventListener('touchend', (e) => {
            if (!dragging) return;
            dragging = false;
            const dx = e.changedTouches[0].clientX - startX;
            const dy = e.changedTouches[0].clientY - startY;
            if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
            this.show(dx < 0 ? this.currentIndex + 1 : this.currentIndex - 1, true);
          }, { passive: true, signal: this.signal });

          this.addEventListener('touchcancel', () => { dragging = false; }, { signal: this.signal });
        }

        _initParallax() {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this._parallaxTargets = [...this.querySelectorAll('.ajwa-hero__slide picture, .ajwa-hero__slide > img')];
          if (!this._parallaxTargets.length) return;
          this._rafPending = false;
          window.addEventListener('scroll', () => {
            if (this._rafPending) return;
            this._rafPending = true;
            requestAnimationFrame(() => {
              this._applyParallax();
              this._rafPending = false;
            });
          }, { passive: true, signal: this.signal });
          this._applyParallax();
        }

        _applyParallax() {
          const rect = this.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          const speed = window.innerWidth < 750 ? 0.1 : 0.2;
          const t = `translateY(${(-rect.top) * speed}px)`;
          this._parallaxTargets.forEach(el => { el.style.transform = t; });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ajwa-ingredient-game"] && !Shopify.designMode) return;
  try {
    
  function shuffle(arr){
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }
  function gameItems(root){
    return [...root.querySelectorAll('[data-item]')].map(el => ({
      term: el.dataset.term,
      detail: el.dataset.detail,
      meta: el.dataset.meta,
      el
    }));
  }
  function showReward(root){
    const reward = root.querySelector('[data-reward]');
    if (reward) reward.hidden = false;
    reward?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  const INGREDIENT_GAME_MODES = {};

  function buildTriviaQuestions(items){
    return items.map((item, i) => {
      const wrongPool = items.filter((_, j) => j !== i);
      const wrong = shuffle(wrongPool).slice(0, 2).map(w => w.detail);
      return {
        question: 'What does ' + item.term + ' do?',
        choices: shuffle([item.detail, ...wrong]),
        answer: item.detail
      };
    });
  }

  function initTrivia(root){
    const items = gameItems(root);
    const questions = shuffle(buildTriviaQuestions(items));
    let index = 0, score = 0;
    const progress = root.querySelector('[data-progress]');
    const questionEl = root.querySelector('[data-question]');
    const choicesEl = root.querySelector('[data-choices]');
    function render(){
      const q = questions[index];
      progress.textContent = 'Question ' + (index + 1) + ' of ' + questions.length;
      questionEl.textContent = q.question;
      choicesEl.innerHTML = '';
      q.choices.forEach(choice => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ajwa-game__card';
        btn.textContent = choice;
        btn.addEventListener('click', () => {
          [...choicesEl.children].forEach(c => c.disabled = true);
          btn.classList.add(choice === q.answer ? 'is-correct' : 'is-wrong');
          if (choice === q.answer) score++;
          setTimeout(() => { index++; index < questions.length ? render() : finish(); }, 700);
        });
        choicesEl.appendChild(btn);
      });
    }
    function finish(){
      questionEl.textContent = 'You scored ' + score + ' out of ' + questions.length + '!';
      choicesEl.innerHTML = '';
      progress.textContent = '';
      showReward(root);
    }
    render();
  }

  function initFlashcard(root){
    const cards = [...root.querySelectorAll('[data-flip]')];
    const flipped = new Set();
    cards.forEach(card => {
      card.addEventListener('click', () => {
        const front = card.querySelector('[data-face-front]');
        const back = card.querySelector('[data-face-back]');
        const nowShowBack = back.hidden;
        front.hidden = nowShowBack;
        back.hidden = !nowShowBack;
        flipped.add(card);
        if (flipped.size === cards.length) showReward(root);
      });
    });
  }

  function initMatch(root){
    const items = gameItems(root);
    const termsEl = root.querySelector('[data-match-terms]');
    const detailsEl = root.querySelector('[data-match-details]');
    let selectedTerm = null;
    let matched = 0;
    shuffle(items).forEach(item => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ajwa-game__card';
      btn.textContent = item.term;
      btn.dataset.pairId = item.term;
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-correct')) return;
        [...termsEl.children].forEach(c => c.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        selectedTerm = btn;
      });
      termsEl.appendChild(btn);
    });
    shuffle(items).forEach(item => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ajwa-game__card';
      btn.textContent = item.detail;
      btn.dataset.pairId = item.term;
      btn.addEventListener('click', () => {
        if (!selectedTerm || btn.classList.contains('is-correct')) return;
        if (selectedTerm.dataset.pairId === btn.dataset.pairId) {
          selectedTerm.classList.add('is-correct');
          btn.classList.add('is-correct');
          selectedTerm.disabled = true;
          btn.disabled = true;
          matched++;
          if (matched === items.length) showReward(root);
        } else {
          btn.classList.add('is-wrong');
          setTimeout(() => btn.classList.remove('is-wrong'), 500);
        }
        selectedTerm.classList.remove('is-selected');
        selectedTerm = null;
      });
      detailsEl.appendChild(btn);
    });
  }

  function initTrueFalse(root){
    const statements = shuffle(gameItems(root));
    let index = 0;
    const statementEl = root.querySelector('[data-statement]');
    const progress = root.querySelector('[data-progress]');
    const explainEl = root.querySelector('[data-explain]');
    const buttons = [...root.querySelectorAll('[data-tf]')];
    function render(){
      explainEl.textContent = '';
      buttons.forEach(b => { b.disabled = false; b.classList.remove('is-correct', 'is-wrong'); });
      const item = statements[index];
      progress.textContent = 'Statement ' + (index + 1) + ' of ' + statements.length;
      statementEl.textContent = item.term;
    }
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const item = statements[index];
        const correct = item.meta === btn.dataset.tf;
        btn.classList.add(correct ? 'is-correct' : 'is-wrong');
        buttons.forEach(b => b.disabled = true);
        explainEl.textContent = item.detail;
        setTimeout(() => {
          index++;
          if (index < statements.length) { render(); } else {
            statementEl.textContent = 'Nice work - you know your SPF!';
            progress.textContent = '';
            explainEl.textContent = '';
            showReward(root);
          }
        }, 1200);
      });
    });
    render();
  }

  function initSequence(root){
    const correctOrder = gameItems(root).map(i => i.term);
    let working = shuffle(correctOrder);
    const list = root.querySelector('[data-seq-list]');
    const result = root.querySelector('[data-seq-result]');
    function render(){
      list.innerHTML = '';
      working.forEach((term, i) => {
        const li = document.createElement('li');
        li.className = 'ajwa-game__seq-item';
        const label = document.createElement('span');
        label.textContent = term;
        const down = document.createElement('button');
        down.type = 'button'; down.textContent = '↓'; down.disabled = i === working.length - 1;
        down.addEventListener('click', () => { [working[i], working[i + 1]] = [working[i + 1], working[i]]; render(); });
        const up = document.createElement('button');
        up.type = 'button'; up.textContent = '↑'; up.disabled = i === 0;
        up.addEventListener('click', () => { [working[i - 1], working[i]] = [working[i], working[i - 1]]; render(); });
        li.appendChild(label);
        li.appendChild(down);
        li.appendChild(up);
        list.appendChild(li);
      });
    }
    root.querySelector('[data-seq-check]').addEventListener('click', () => {
      const isCorrect = working.every((term, i) => term === correctOrder[i]);
      result.textContent = isCorrect ? 'Perfect routine!' : 'Not quite - try reordering with the arrows.';
      if (isCorrect) showReward(root);
    });
    render();
  }

  function initWheel(root){
    const items = gameItems(root);
    const dial = root.querySelector('[data-wheel-dial]');
    const resultEl = root.querySelector('[data-wheel-result]');
    const spinBtn = root.querySelector('[data-wheel-spin]');
    const seen = new Set();
    let rotation = 0;
    spinBtn.addEventListener('click', () => {
      spinBtn.disabled = true;
      const pick = items[Math.floor(Math.random() * items.length)];
      rotation += 720 + Math.floor(Math.random() * 360);
      dial.style.transform = 'rotate(' + rotation + 'deg)';
      setTimeout(() => {
        resultEl.textContent = pick.term + ': ' + pick.detail;
        seen.add(pick.term);
        spinBtn.disabled = false;
        if (seen.size === items.length) showReward(root);
      }, 900);
    });
  }

  function initWordsearch(root){
    const words = gameItems(root).map(i => i.term.toUpperCase().replace(/[^A-Z]/g, ''));
    const size = Math.max(...words.map(w => w.length)) + 2;
    const grid = Array.from({ length: words.length }, () => Array(size).fill(null));
    const placements = words.map((word, r) => {
      const maxStart = size - word.length;
      const start = Math.floor(Math.random() * (maxStart + 1));
      for (let c = 0; c < word.length; c++) grid[r][start + c] = word[c];
      return { word, row: r, startCol: start, endCol: start + word.length - 1 };
    });
    for (let r = 0; r < words.length; r++) {
      for (let c = 0; c < size; c++) {
        if (!grid[r][c]) grid[r][c] = String.fromCharCode(65 + Math.floor(Math.random() * 26));
      }
    }
    const boardEl = root.querySelector('[data-ws-grid]');
    const listEl = root.querySelector('[data-ws-words]');
    boardEl.style.setProperty('--ws-cols', size);
    let selection = [];
    const found = new Set();
    words.forEach(w => {
      const li = document.createElement('li');
      li.textContent = w;
      li.dataset.word = w;
      listEl.appendChild(li);
    });
    grid.forEach((row, r) => row.forEach((letter, c) => {
      const cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'ajwa-game__ws-cell';
      cell.textContent = letter;
      cell.dataset.row = r;
      cell.dataset.col = c;
      cell.addEventListener('click', () => {
        if (cell.classList.contains('is-correct')) return;
        cell.classList.toggle('is-selected');
        selection = selection.filter(s => s !== cell);
        if (cell.classList.contains('is-selected')) selection.push(cell);
        if (selection.length === 2) {
          const [a, b] = selection;
          const ra = Number(a.dataset.row), rb = Number(b.dataset.row);
          const ca = Number(a.dataset.col), cb = Number(b.dataset.col);
          const placement = placements.find(p => p.row === ra && ra === rb &&
            p.startCol === Math.min(ca, cb) && p.endCol === Math.max(ca, cb));
          if (placement) {
            for (let c = placement.startCol; c <= placement.endCol; c++) {
              boardEl.querySelector('[data-row="' + ra + '"][data-col="' + c + '"]').classList.add('is-correct');
            }
            found.add(placement.word);
            listEl.querySelector('[data-word="' + placement.word + '"]').classList.add('is-correct');
            if (found.size === words.length) showReward(root);
          }
          selection.forEach(s => s.classList.remove('is-selected'));
          selection = [];
        }
      });
      boardEl.appendChild(cell);
    }));
  }

  function initGuess(root){
    const words = shuffle(gameItems(root));
    const maxWrong = 6;
    let index = 0;
    let wrongCount = 0;
    let revealed = [];
    const progress = root.querySelector('[data-progress]');
    const hintEl = root.querySelector('[data-guess-hint]');
    const wordEl = root.querySelector('[data-guess-word]');
    const keysEl = root.querySelector('[data-guess-keys]');
    const statusEl = root.querySelector('[data-guess-status]');
    function renderWord(letters){
      wordEl.textContent = revealed.map((ch, i) => ch || (letters[i] === ' ' ? '  ' : '_')).join(' ');
    }
    function render(){
      const item = words[index];
      const letters = item.term.toUpperCase().split('');
      revealed = letters.map(ch => ch === ' ' ? ' ' : null);
      wrongCount = 0;
      progress.textContent = 'Ingredient ' + (index + 1) + ' of ' + words.length;
      hintEl.textContent = 'Hint: ' + item.detail;
      statusEl.textContent = '';
      renderWord(letters);
      keysEl.innerHTML = '';
      'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(letter => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ajwa-game__card';
        btn.textContent = letter;
        btn.addEventListener('click', () => {
          btn.disabled = true;
          if (letters.includes(letter)) {
            letters.forEach((ch, i) => { if (ch === letter) revealed[i] = letter; });
            btn.classList.add('is-correct');
            renderWord(letters);
            if (revealed.every((ch, i) => ch !== null || letters[i] === ' ')) {
              statusEl.textContent = 'Got it - ' + item.term + '!';
              setTimeout(next, 1000);
            }
          } else {
            btn.classList.add('is-wrong');
            wrongCount++;
            if (wrongCount >= maxWrong) {
              revealed = letters.slice();
              renderWord(letters);
              statusEl.textContent = 'The answer was ' + item.term + '.';
              setTimeout(next, 1200);
            }
          }
        });
        keysEl.appendChild(btn);
      });
    }
    function next(){
      index++;
      if (index < words.length) { render(); } else {
        wordEl.textContent = '';
        hintEl.textContent = '';
        progress.textContent = '';
        statusEl.textContent = 'You guessed every ingredient!';
        keysEl.innerHTML = '';
        showReward(root);
      }
    }
    render();
  }

  function initSlider(root){
    const questions = gameItems(root);
    let index = 0;
    const progress = root.querySelector('[data-progress]');
    const questionEl = root.querySelector('[data-slider-question]');
    const input = root.querySelector('[data-slider-input]');
    const valueEl = root.querySelector('[data-slider-value]');
    const resultEl = root.querySelector('[data-slider-result]');
    const guessBtn = root.querySelector('[data-slider-guess]');
    input.addEventListener('input', () => { valueEl.textContent = input.value; });
    function render(){
      const q = questions[index];
      progress.textContent = 'Guess ' + (index + 1) + ' of ' + questions.length;
      questionEl.textContent = q.term;
      resultEl.textContent = '';
      input.value = 5;
      valueEl.textContent = '5';
      guessBtn.disabled = false;
    }
    guessBtn.addEventListener('click', () => {
      const q = questions[index];
      const guess = Number(input.value);
      const answer = Number(q.meta);
      resultEl.textContent = (guess === answer ? 'Spot on! ' : 'The answer was ' + answer + '. ') + q.detail;
      guessBtn.disabled = true;
      setTimeout(() => {
        index++;
        if (index < questions.length) { render(); } else {
          questionEl.textContent = 'Thanks for playing!';
          progress.textContent = '';
          resultEl.textContent = '';
          showReward(root);
        }
      }, 1600);
    });
    render();
  }

  function initMemory(root){
    const items = gameItems(root);
    const cards = shuffle(items.flatMap((item, i) => ([
      { pairId: i, label: item.term },
      { pairId: i, label: item.detail }
    ])));
    const board = root.querySelector('[data-memory]');
    let open = [];
    let matched = 0;
    cards.forEach(card => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ajwa-game__card ajwa-game__memory-card';
      btn.textContent = '?';
      btn.dataset.pairId = card.pairId;
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-correct') || btn.classList.contains('is-open') || open.length === 2) return;
        btn.textContent = card.label;
        btn.classList.add('is-open');
        open.push(btn);
        if (open.length === 2) {
          const [a, b] = open;
          if (a.dataset.pairId === b.dataset.pairId && a !== b) {
            a.classList.add('is-correct');
            b.classList.add('is-correct');
            matched++;
            open = [];
            if (matched === items.length) showReward(root);
          } else {
            setTimeout(() => {
              a.textContent = '?';
              b.textContent = '?';
              a.classList.remove('is-open');
              b.classList.remove('is-open');
              open = [];
            }, 700);
          }
        }
      });
      board.appendChild(btn);
    });
  }

  function initBingo(root){
    const items = gameItems(root);
    const grid = root.querySelector('[data-bingo-grid]');
    let marked = 0;
    items.forEach(item => {
      const cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'ajwa-game__card ajwa-game__bingo-cell';
      cell.innerHTML = '<strong></strong><span></span>';
      cell.querySelector('strong').textContent = item.term;
      cell.querySelector('span').textContent = item.detail;
      cell.addEventListener('click', () => {
        if (cell.classList.contains('is-correct')) return;
        cell.classList.add('is-correct');
        marked++;
        if (marked === items.length) showReward(root);
      });
      grid.appendChild(cell);
    });
  }

  function initSpeed(root){
    const items = gameItems(root);
    const questions = shuffle(buildTriviaQuestions(items));
    const seconds = 8;
    let index = 0, score = 0, timer = null;
    const progress = root.querySelector('[data-progress]');
    const questionEl = root.querySelector('[data-question]');
    const choicesEl = root.querySelector('[data-choices]');
    const timerEl = root.querySelector('[data-speed-timer]');
    function answer(choice, q, btn){
      clearInterval(timer);
      [...choicesEl.children].forEach(c => c.disabled = true);
      if (btn) btn.classList.add(choice === q.answer ? 'is-correct' : 'is-wrong');
      if (choice === q.answer) score++;
      setTimeout(() => { index++; index < questions.length ? render() : finish(); }, 600);
    }
    function render(){
      let remaining = seconds;
      const q = questions[index];
      progress.textContent = 'Question ' + (index + 1) + ' of ' + questions.length;
      questionEl.textContent = q.question;
      timerEl.textContent = remaining + 's';
      choicesEl.innerHTML = '';
      q.choices.forEach(choice => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ajwa-game__card';
        btn.textContent = choice;
        btn.addEventListener('click', () => answer(choice, q, btn));
        choicesEl.appendChild(btn);
      });
      clearInterval(timer);
      timer = setInterval(() => {
        remaining--;
        timerEl.textContent = remaining + 's';
        if (remaining <= 0) { clearInterval(timer); answer(null, q, null); }
      }, 1000);
    }
    function finish(){
      questionEl.textContent = 'Speed round complete - ' + score + '/' + questions.length + '!';
      choicesEl.innerHTML = '';
      progress.textContent = '';
      timerEl.textContent = '';
      showReward(root);
    }
    render();
  }

  INGREDIENT_GAME_MODES.match = initMatch;
  INGREDIENT_GAME_MODES.true_false = initTrueFalse;
  INGREDIENT_GAME_MODES.sequence = initSequence;
  INGREDIENT_GAME_MODES.puzzle = initSequence;
  INGREDIENT_GAME_MODES.wheel = initWheel;
  INGREDIENT_GAME_MODES.wordsearch = initWordsearch;
  INGREDIENT_GAME_MODES.guess = initGuess;
  INGREDIENT_GAME_MODES.slider = initSlider;
  INGREDIENT_GAME_MODES.memory = initMemory;
  INGREDIENT_GAME_MODES.bingo = initBingo;
  INGREDIENT_GAME_MODES.speed = initSpeed;

  INGREDIENT_GAME_MODES.flashcard = initFlashcard;

  INGREDIENT_GAME_MODES.trivia = initTrivia;

  if (!customElements.get('ingredient-game')) customElements.define('ingredient-game', class extends HTMLElement {
    connectedCallback(){
      this.querySelector('[data-copy-code]')?.addEventListener('click', (event) => {
        const code = this.querySelector('[data-reward-code]').textContent.trim();
        navigator.clipboard?.writeText(code);
        event.target.textContent = 'Copied!';
      });
      const mode = this.dataset.mode;
      const init = INGREDIENT_GAME_MODES[mode];
      if (init) init(this);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ajwa-product-highlights"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ajwa-ph').forEach(function (section) {
      var id = section.className.match(/ajwa-ph--(\S+)/)?.[1];
      var tabs = section.querySelectorAll('.ajwa-ph__tab');
      var panels = section.querySelectorAll('.ajwa-ph__panel');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.panel;
          tabs.forEach(function (t) {
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          panels.forEach(function (panel) {
            panel.classList.toggle('ajwa-ph__panel--hidden', panel.id !== 'panel-' + target + '-' + id);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ajwa-routine-bundles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('routine-bundle')) customElements.define('routine-bundle', class extends HTMLElement {
    connectedCallback(){this.querySelector('[data-add-bundle]')?.addEventListener('click',()=>this.add());}
    async add(){const button=this.querySelector('[data-add-bundle]');const status=this.querySelector('[data-bundle-status]');const items=[...this.querySelectorAll('[data-variant-id][data-available="true"]')].map(el=>({id:Number(el.dataset.variantId),quantity:1}));if(!items.length)return;button.disabled=true;status.textContent='Adding routine…';try{const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});if(!response.ok)throw new Error();status.textContent='Routine added to cart.';document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true}));}catch(error){status.textContent='Unable to add the routine. Please add products individually.';}finally{button.disabled=false;}}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ajwa-shoppable-media"] && !Shopify.designMode) return;
  try {
    
  if (!window.ajwaMediaHoverPlayback) {
    window.ajwaMediaHoverPlayback = true;
    document.addEventListener('pointerenter', (event) => {
      const card = event.target.closest?.('.ajwa-media--pause-hover .ajwa-media__card');
      card?.querySelector('video')?.pause();
    }, true);
    document.addEventListener('pointerleave', (event) => {
      const section = event.target.closest?.('.ajwa-media--pause-hover');
      const video = event.target.closest?.('.ajwa-media__card')?.querySelector('video');
      if (section?.dataset.autoplay === 'true') video?.play().catch(() => {});
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ajwa-skin-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('skin-quiz')) {
    customElements.define('skin-quiz', class extends HTMLElement {
      connectedCallback() {
        this.querySelector('form')?.addEventListener('submit', (event) => {
          event.preventDefault();
          const selected = this.querySelector('input:checked');
          if (!selected) {
            this.querySelector('.ajwa-quiz__message').textContent = 'Choose an answer to see your routine.';
            return;
          }
          if (selected.dataset.link) window.location.href = selected.dataset.link;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
